import { useResolvedPath, useMatch, NavLink, useLocation, matchPath } from 'react-router-dom';
import { useState } from 'react';
import './nav-item.css';
import { arrayAny } from '../../utils/arrayUtils';
import { useMenuContext } from '../../app';

export const NavItem = ({ menu, parentTitle, ...props }) => {

    let location = useLocation();
    let resolved = useResolvedPath(menu.path);
    let routeMatch = useMatch({ path: resolved.pathname }) || matchPath({ path: menu.path, end: false, }, location.pathname);
    let match = menu.path === '#' ? false : routeMatch;
    
    const menuContext = useMenuContext();
    const { activeMenu, setActiveMenu, expandedMenu, setExpandedMenu } = menuContext || {};
    
    const isExpanded = expandedMenu === menu.title;
    const isActive = (activeMenu === menu.title) || (!activeMenu && match);
    
    const handleParentClick = (e) => {
        if (menu.children) {
            e.preventDefault();
            const newExpanded = !isExpanded;
            
            if (setExpandedMenu) {
                setExpandedMenu(newExpanded ? menu.title : null);
            }
            if (setActiveMenu) {
                setActiveMenu(newExpanded ? menu.title : null);
            }
        }
    };
    
    const handleRegularClick = () => {
        if (setActiveMenu) {
            setActiveMenu(menu.title);
        }
        // Only collapse expanded menu if this is NOT a child of the expanded menu
        if (setExpandedMenu && !parentTitle) {
            setExpandedMenu(null);
        }
    };

    let icon = menu.icon && <div className="menu-icon"><i className={menu.icon}></i></div>;
    let img = menu.img && <div className="menu-icon-img"><img src={menu.img} alt="" /></div>;
    let caret = (arrayAny(menu.children)) && <div className="menu-caret"></div>;
    let label = menu.label && <span className="menu-label ms-5px">{menu.label}</span>;
    let badge = (menu.badge || menu.badgeLoading) && (
        <div className="menu-badge">
            {menu.badgeLoading ? (
                <i className="fa fa-spinner fa-spin" style={{fontSize: '10px'}}></i>
            ) : (
                menu.badge
            )}
        </div>
    );
    let highlight = menu.highlight && <i className="fa fa-paper-plane text-theme"></i>;
    let title = menu.title && <div className="menu-text">{menu.title} {label} {highlight}</div>;

    return (
        <div className={'menu-item' + (isActive ? ' active' : '') + (menu.children ? ' has-sub' : '') + (isExpanded ? ' expand' : '')}>
            {menu.path === '#' ? (
                <a className="menu-link" href="#" onClick={handleParentClick}>
                    {img}{icon}{title}{badge}{caret}
                </a>
            ) : (
                <NavLink className="menu-link" to={menu.path} onClick={handleRegularClick}>
                    {img}{icon}{title}{badge}{caret}
                </NavLink>
            )}

            {menu.children && ( // Sub-menu items
                <div className="menu-submenu" style={{ display: isExpanded ? 'block' : 'none' }}>
                    {menu.children.map((submenu, i) => (
                        <NavItem key={i} menu={submenu} parentTitle={menu.title} />
                    ))}
                </div>
            )}
        </div>
    );
}